export const STRIPE_PUBLIC_KEY = "pk_live_qdZwUtmXEJ7rl9zxACg1tMFs";
export const STRIPE_PLANS = [
        {
            "name": "Single",
            "price": 59900,
            "stripe_plan": "single_2020",
            "img": "img/icons/single.png",
            "locations": "1 Listing",
            "features": ["Verified Status","Magic Diet Plugin", "Dietary Analytics", "No menu limit", "Shareable Deeplink", "NFC Suite"]
        },
        {
            "name": "Group",
            "price": 99900,
            "stripe_plan": "group_2020",
            "img": "img/icons/group.png",
            "locations": "Up to 5 Locations",
            "features": ["Verified Status","Magic Diet Plugin", "Dietary Analytics", "No menu limit", "Shareable Deeplink", "NFC Suite"]
        }
    ]

export const TAX_RATE = 0.05


// WEBPACK FOOTER //
// ./src/views/Account/constants.js